import { Editor } from '@tiptap/core';
import { IconType } from 'react-icons';
import { LuHeading1, LuHeading2, LuHeading3 } from 'react-icons/lu';
import {
  MdCode,
  MdFormatBold,
  MdFormatItalic,
  MdFormatListBulleted,
  MdFormatListNumbered,
  MdFormatQuote,
  MdFormatStrikethrough,
  MdFormatUnderlined,
  MdSubscript,
  MdSuperscript,
} from 'react-icons/md';

export type FormatFlagKey =
  | 'bold'
  | 'italic'
  | 'underline'
  | 'strike'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'bulletList'
  | 'orderedList'
  | 'blockquote'
  | 'codeBlock'
  | 'subscript'
  | 'superscript';

type FormatItem = {
  key: FormatFlagKey;
  Icon: IconType;
  tooltip: string;
  run: (editor: Editor) => void;
  /** Hidden unless listed in `allowedFormats`, so existing editors keep their toolbar. */
  optIn?: boolean;
};

export const FORMAT_ITEMS: FormatItem[] = [
  { key: 'bold', Icon: MdFormatBold, tooltip: 'Bold', run: e => e.chain().focus().toggleBold().run() },
  { key: 'italic', Icon: MdFormatItalic, tooltip: 'Italic', run: e => e.chain().focus().toggleItalic().run() },
  {
    key: 'underline',
    Icon: MdFormatUnderlined,
    tooltip: 'Underline',
    run: e => e.chain().focus().toggleUnderline().run(),
  },
  {
    key: 'strike',
    Icon: MdFormatStrikethrough,
    tooltip: 'Strikethrough',
    run: e => e.chain().focus().toggleStrike().run(),
  },
  { key: 'h1', Icon: LuHeading1, tooltip: 'Heading 1', run: e => e.chain().focus().toggleHeading({ level: 1 }).run() },
  { key: 'h2', Icon: LuHeading2, tooltip: 'Heading 2', run: e => e.chain().focus().toggleHeading({ level: 2 }).run() },
  { key: 'h3', Icon: LuHeading3, tooltip: 'Heading 3', run: e => e.chain().focus().toggleHeading({ level: 3 }).run() },
  {
    key: 'bulletList',
    Icon: MdFormatListBulleted,
    tooltip: 'Bullet list',
    run: e => e.chain().focus().toggleBulletList().run(),
  },
  {
    key: 'orderedList',
    Icon: MdFormatListNumbered,
    tooltip: 'Ordered list',
    run: e => e.chain().focus().toggleOrderedList().run(),
  },
  {
    key: 'blockquote',
    Icon: MdFormatQuote,
    tooltip: 'Blockquote',
    run: e => e.chain().focus().toggleBlockquote().run(),
  },
  { key: 'codeBlock', Icon: MdCode, tooltip: 'Code block', run: e => e.chain().focus().toggleCodeBlock().run() },
  {
    key: 'subscript',
    Icon: MdSubscript,
    tooltip: 'Subscript',
    run: e => e.chain().focus().toggleSubscript().run(),
    optIn: true,
  },
  {
    key: 'superscript',
    Icon: MdSuperscript,
    tooltip: 'Superscript',
    run: e => e.chain().focus().toggleSuperscript().run(),
    optIn: true,
  },
];
